// client/src/components/utils/bankData.js

/**
 * Lista completa delle banche italiane
 * Dati aggiornati e ordinati alfabeticamente
 */
export const ITALIAN_BANKS = [
  'ABANCA',
  'ABN AMRO',
  'Agricultural Bank of China',
  'AIB Group (Allied Irish Banks)',
  'Allianz Bank',
  'Alpha Bank',
  'Argenta Spaarbank',
  'Australia and New Zealand Banking Group (ANZ)',
  'Banca Agricola Popolare di Sicilia',
  'Banca Aidexa',
  'Banca Akros',
  'Banca Aletti',
  'Banca Alpi Marittime Credito Cooperativo Carrù',
  'Banca Alta Toscana Credito Cooperativo',
  'Banca Cambiano 1884',
  'Banca Cassa Risparmio di Savigliano',
  'Banca Centro - Credito Cooperativo Toscana - Umbria',
  'Banca Centropadana',
  'Banca Cesare Ponti',
  'Banca CF+',
  'Banca Credifarma',
  'Banca Cremasca e Mantovana',
  'Banca D\'Alba Credito Cooperativo',
  'Banca dei Sibillini - Credito Cooperativo di Casavecchia',
  'Banca del Fucino',
  'Banca del Mezzogiorno - Mediocredito Centrale',
  'Banca del Piemonte',
  'Banca della Marca Credito Cooperativo di Orsago',
  'Banca della Nuova Terra',
  'Banca della Valsassina Credito Cooperativo',
  'Banca Della Versilia Lunigiana e Garfagnana',
  'Banca dell\'Alta Murgia',
  'Banca dell\'Elba',
  'Banca di Ancona e Falconara Marittima',
  'Banca di Andria di Credito Cooperativo',
  'Banca di Anghiari e Stiacredito Cooperativo',
  'Banca di Bari e Taranto',
  'Banca di Caraglio, del Cuneese e Della Riviera dei Fiori',
  'Banca di Cividale',
  'Banca di Credito Popolare -Torre Del Greco',
  'Banca di Imola',
  'Banca di Pescia e Cachia Credito Cooperativo',
  'Banca di Piacenza',
  'Banca di Sconto',
  'Banca Finint',
  'Banca Finnat Euramerica',
  'Banca Generali',
  'Banca Ifigest',
  'Banca Ifis',
  'Banca Investis',
  'Banca Macerata',
  'Banca Malatestiana',
  'Banca Mediolanum',
  'Banca Monte dei Paschi di Siena',
  'Banca Nazionale del Lavoro',
  'Banca Passadore & C.',
  'Banca Patrimoni Sella & C.',
  'Banca per il Trentino Alto Adigebank für Trentino-Südtirol',
  'Banca per lo Sviluppo della Cooperazione di Credito',
  'Banca Popolare Commerciale',
  'Banca Popolare del Cassinate',
  'Banca Popolare del Frusinate',
  'Banca Popolare del Lazio',
  'Banca Popolare dell\'Alto Adige',
  'Banca Popolare di Cortona',
  'Banca Popolare di Fondi',
  'Banca Popolare di Lajatico',
  'Banca Popolare di Puglia e Basilicata',
  'Banca Popolare di Sondrio',
  'Banca Popolare Etica',
  'Banca Popolare Province Molisane',
  'Banca Popolare Pugliese',
  'Banca Profilo',
  'Banca Progetto',
  'Banca Promos',
  'Banca Reale',
  'Banca Santa Giulia',
  'Banca Sella',
  'Banca Simetica',
  'Banca Sistema',
  'Banca Stabiese',
  'Banca Transilvania',
  'Banca Ubae',
  'Banca Valsabbina',
  'Banca Veronese Credito Cooperativo di Concamarise',
  'Banca Widiba',
  'Banco BPI',
  'Banco BPM',
  'Banco di Credito P. Azzoaglio',
  'Banco di Desio e Della Brianza',
  'Banco di Lucca e del Tirreno',
  'Banco di Sardegna',
  'Banco Fiorentino - Mugello Impruneta Signa',
  'Banco Marchigiano',
  'Banco Sabadell',
  'Banco Santander',
  'Bank of America',
  'Bank of China',
  'Bank of China (BOC)',
  'Bank of Ireland Group',
  'Bank of Montreal (BMO)',
  'Bank of Nova Scotia (Scotiabank)',
  'Bank Pekao',
  'Bank Sepah',
  'Bankinter',
  'Banque et Caisse d\'Épargne de l\'État (Spuerkeess / BCEE)',
  'Barclays',
  'BAWAG Group',
  'BayernLB (Bayerische Landesbank)',
  'BBVA',
  'BCA Banca',
  'BCC "G. Toniolo" e san Michele di san Cataldo',
  'BCC 360',
  'BCC Abruzzese - Cappelle sul Tavo',
  'BCC Adria Colli Euganei',
  'BCC Agrigentino',
  'BCC Agrobresciano',
  'BCC Appulo Lucana',
  'BCC Basilicata di Laurenzana e Comuni Lucani',
  'BCC Bergamasca e Orobica',
  'BCC Brianza e Laghi',
  'BCC BTM',
  'BCC Campania Centrocassa Rurale ed Artigiana',
  'BCC Cassa Padana',
  'BCC Centro Emilia',
  'BCC Centro Lazio',
  'BCC Chianti',
  'BCC Cortina',
  'BCC degli Uliviterra di Bari',
  'BCC dei Castelli e degli Iblei',
  'BCC dei Castelli Romani e del Tuscolo',
  'BCC dei Colli Albani',
  'BCC del Basso Sebino',
  'BCC del Circeo e Privernate',
  'BCC del Garda',
  'BCC del Metauro',
  'BCC del Piceno',
  'BCC del Territorio Lombardo',
  'BCC del Valdarno',
  'BCC della Calabria Ulteriore',
  'BCC della Provincia Romana',
  'BCC della Romagna Occidentale',
  'BCC della Valle del Fitalia',
  'BCC della Valle del Trigno',
  'BCC dell\'Adriatico Teramano',
  'BCC dell\'Alto Tirreno Della Calabria',
  'BCC delle Madonie',
  'BCC delle Terre Venete',
  'BCC dell\'Oglio e del Serio',
  'BCC di Abruzzi e Molise',
  'BCC di Alberobello Sammichele e Monopoli',
  'BCC di Altofonte e Caccamo',
  'BCC di Anagni',
  'BCC di Aquara',
  'BCC di Arborea',
  'BCC di Avetrana',
  'BCC di Barlassina',
  'BCC di Basciano',
  'BCC di Bellegra',
  'BCC di Bologna',
  'BCC di Busto Garolfo e Buguggiate',
  'BCC di Cagliari',
  'BCC di Canosaloconia',
  'BCC di Capaccio-Paestum e Serino',
  'BCC di Carate Brianza',
  'BCC di Cassano Delle Murge e Tolve',
  'BCC di Castiglione Messer Raimondo e Pianella',
  'BCC di Cherasco',
  'BCC di Conversano',
  'BCC di Fano',
  'BCC di Filottrano e Camerano',
  'BCC di Flumeri',
  'BCC di Gambatesa',
  'BCC di Gaudiano di Lavello',
  'BCC di Leverano',
  'BCC di Lezzeno',
  'BCC di Locorotondo Cassa Rurale ed Artigiana',
  'BCC di Marina di Ginosa',
  'BCC di Milano',
  'BCC di Montepaone',
  'BCC di Mozzanica',
  'BCC di Napoli',
  'BCC di Nettuno',
  'BCC di Ostra e Morro D\'Alba',
  'BCC di Ostra Vetere',
  'BCC di Ostuni',
  'BCC di Pachino',
  'BCC di Pergola e Corinaldo',
  'BCC di Pesaro',
  'BCC di Pianfei e Rocca de\' Baldi',
  'BCC di Pisa e di Fornacette',
  'BCC di Pontassieve',
  'BCC di Pratola Peligna',
  'BCC di Putignano',
  'BCC di Recanati e Colmurano',
  'BCC di Ripatransone e del Fermano',
  'BCC di Roma',
  'BCC di San Giovanni Rotondo',
  'BCC di San Marco dei Cavoti e del Sannio Calvi',
  'BCC di san Marzano di San Giuseppetaranto',
  'BCC di Santeramo in Colle',
  'BCC di Sarsina',
  'BCC di Scafati e Cetara',
  'BCC di Spello e del Velino',
  'BCC di Terra D\'Otranto',
  'BCC di Trieste e Gorizia ZKB',
  'BCC di Udine',
  'BCC di Venezia Padova e Rovigobanca Annia',
  'BCC Don Rizzo della Sicilia Occidentale',
  'BCC Felsinea dal 1902',
  'BCC Financing',
  'BCC la Riscossa di Regalbuto',
  'BCC Lazio Nord',
  'BCC Leasing',
  'BCC Lodi',
  'BCC Magna Grecia',
  'BCC Monte Pruno di Fisciano Roscigno e Laurino',
  'BCC Pordenonese e Monsile',
  'BCC Prealpi San Biagio',
  'BCC Romagna Est e Sala di Cesenatico',
  'BCC San Francesco',
  'BCC Sicilbanca',
  'BCC Terra di Lavoros. Vincenzo de\' Paoli',
  'BCC Terre Etrusche di Valdichiana e di Maremma',
  'BCC Valdostana',
  'BCC Valle del Lambro',
  'BCC Valle del Torto',
  'BCC Veneta',
  'BCC Veneto Centrale',
  'BCC Venezia Giulia',
  'BCC Vicentino',
  'BDM Banca',
  'Belfius Bank',
  'Bene Banca Credito Cooperativo di Bene Vagienna',
  'BFF Bank',
  'Bibanca',
  'Blu Banca',
  'BNP Paribas',
  'BNY Mellon',
  'BPER',
  'BRD – Groupe Société Générale',
  'CA Auto Bank',
  'Caixa Geral de Depósitos (CGD)',
  'CaixaBank',
  'Canadian Imperial Bank of Commerce (CIBC)',
  'Cassa Centrale Banca',
  'Cassa Centrale Raiffeisen Dell\'Alto Adige',
  'Cassa di Fassa Primiero e Belluno',
  'Cassa di Ravenna',
  'Cassa di Risparmio di Asti',
  'Cassa di Risparmio di Bolzano',
  'Cassa di Risparmio di Fermo',
  'Cassa di Risparmio di Fossano',
  'Cassa di Risparmio di Volterra',
  'Cassa Lombarda',
  'Cassa Raiffeisen Alta Pusteria',
  'Cassa Raiffeisen Alta Venosta',
  'Cassa Raiffeisen Bassa Atesina',
  'Cassa Raiffeisen Bassa Vall\'Isarco',
  'Cassa Raiffeisen Bassa Venosta',
  'Cassa Raiffeisen Campo di Trens',
  'Cassa Raiffeisen Castelrotto',
  'Cassa Raiffeisen Della val Passiria',
  'Cassa Raiffeisen Della Valle Isarco',
  'Cassa Raiffeisen di Bolzano',
  'Cassa Raiffeisen di Brunico',
  'Cassa Raiffeisen di Dobbiaco Raiffeisenkasse Toblach',
  'Cassa Raiffeisen di Funes',
  'Cassa Raiffeisen di Lacesraiffeisenkasse Latsch',
  'Cassa Raiffeisen di Lagundoraiffeisenkasse Algund',
  'Cassa Raiffeisen di Lasa',
  'Cassa Raiffeisen di Marlengo',
  'Cassa Raiffeisen di Monguelfo-Casies-Tesido',
  'Cassa Raiffeisen di Nova Ponentealdino',
  'Cassa Raiffeisen di Parcines Raiffeisenkasse Partschins',
  'Cassa Raiffeisen di San Martino in Passiria',
  'Cassa Raiffeisen di Scena',
  'Cassa Raiffeisen di Tesimo',
  'Cassa Raiffeisen di Vandoies',
  'Cassa Raiffeisen di Villabassa Raiffeisenkasse Niederdorf',
  'Cassa Raiffeisen Etschtal',
  'Cassa Raiffeisen Lana',
  'Cassa Raiffeisen Merano',
  'Cassa Raiffeisen Oltradige',
  'Cassa Raiffeisen Pratotubre',
  'Cassa Raiffeisen Schlernrosengarten',
  'Cassa Raiffeisen Silandro Raiffeisenkasse Schlanders',
  'Cassa Raiffeisen Tirolo',
  'Cassa Raiffeisen Turesaurina',
  'Cassa Raiffeisen Ultimo San Pancrazio Lauregno',
  'Cassa Raiffeisen val Badia',
  'Cassa Raiffeisen val Gardena Raiffeisenkasse Groden Genossenschaft',
  'Cassa Raiffeisen val Sarentino',
  'Cassa Raiffeisen Wipptal',
  'Cassa Risparmio di Orvieto',
  'Cassa Rurale Alta val Sugana',
  'Cassa Rurale Alto Gardarovereto',
  'Cassa Rurale Bassa Vallagarina',
  'Cassa Rurale BCC di Treviglio',
  'Cassa Rurale di Ledro',
  'Cassa Rurale di Salorno',
  'Cassa Rurale ed Artigiana di Binasco',
  'Cassa Rurale ed Artigiana di Borgo san Giacomo',
  'Cassa Rurale ed Artigiana di Boves',
  'Cassa Rurale ed Artigiana di Cantù',
  'Cassa Rurale ed Artigiana di Castellana Grotte',
  'Cassa Rurale ed Artigiana di Paliano',
  'Cassa Rurale ed Artigiana di Rivarolo Mantovano',
  'Cassa Rurale FVG',
  'Cassa Rurale Renon',
  'Cassa Rurale val di Fiemme',
  'Cassa Rurale val di Nonrotaliana e Giovo',
  'Cassa Rurale val di Sole',
  'Cassa Rurale Valsugana e Tesino',
  'Castagneto Banca 1910',
  'Centromarca BCC di Treviso e Venezia',
  'Cherry Bank',
  'China Construction Bank (CCB)',
  'Citibank',
  'Commerzbank',
  'Commonwealth Bank of Australia (CBA)',
  'Compass',
  'Credem (Credito Emiliano)',
  'Credifriuli - Credito Cooperativo Friuli',
  'Crédit Agricole',
  'Crédit Mutuel (BFCM/CMAF)',
  'Credito Cooperativo Cassa Rurale ed Artigiana di Erchie',
  'Credito Cooperativo Centro Calabria',
  'Credito Cooperativo di Bresciasocietà Coop.',
  'Credito Cooperativo di Caravaggio Adda e Cremasco',
  'Credito Cooperativo Mediocrati',
  'Credito Cooperativo Ravennate Forlivese ed Imolese',
  'Credito Cooperativo Romagnolo - BCC di Cesena e Gatteo',
  'Credito Cooperativo Valdarno Fiorentinobanca di Cascia',
  'Credito Lombardo Veneto',
  'Credito Padano',
  'Danske Bank',
  'DBS Bank',
  'De Volksbank',
  'DekaBank',
  'Deutsche Bank',
  'DNB Bank',
  'DZ Bank',
  'Emil Banca',
  'Ersel',
  'Erste Group Bank',
  'Eurobank',
  'Extrabanca',
  'Fideuram',
  'Fineco',
  'Finint',
  'Goldman Sachs',
  'Guber Banca',
  'Hamburg Commercial Bank (HCOB)',
  'Hana Bank (KEB Hana Bank)',
  'Helaba (Landesbank Hessen-Thüringen)',
  'HSBC',
  'IBL Banca',
  'Iccrea Banca',
  'Igea Digital Bank',
  'Illimity Bank',
  'Imprebanca',
  'ICBC',
  'ING Bank',
  'Intesa Sanpaolo',
  'Istituto per il Credito Sportivo e Culturale',
  'Itaú Unibanco',
  'JP Morgan',
  'Jyske Bank',
  'KBC Group',
  'Kutxabank',
  'La Banque Postale',
  'La Cassa Rurale - Credito Cooperativo Adamello Giudicarie Valsabbia Paganella',
  'LBBW (Landesbank Baden-Württemberg)',
  'Lloyds Banking Group',
  'Mediobanca',
  'Mediocredito Trentino-Alto Adige',
  'Millennium bcp',
  'Mizuho Bank',
  'Morgan Stanley',
  'MUFG Bank',
  'National Australia Bank (NAB)',
  'National Bank of Greece (NBG)',
  'Natixis',
  'NatWest Group',
  'NIBC Bank',
  'Nordea Bank',
  'NordLB (Norddeutsche Landesbank)',
  'Novo Banco',
  'Nykredit',
  'Oberbank',
  'OCBC Bank',
  'OP Financial Group',
  'Permanent TSB',
  'Persia International Bank Plc',
  'Piraeus Bank',
  'PKO Bank Polski',
  'Prader Bank',
  'Primacassa',
  'Rabobank',
  'Raiffeisen Bank International (RBI)',
  'Rivierabanca Credito Cooperativo di Rimini e Gradara',
  'Royal Bank of Canada (RBC)',
  'Sanfelice 1893 Banca Popolare',
  'Shinhan Bank',
  'Skandinaviska Enskilda Banken (SEB)',
  'Smart Bank',
  'Société Générale',
  'Solution Bank',
  'Standard Chartered',
  'State Street',
  'Sudtirol Bank',
  'Sumitomo Mitsui Financial Group (SMBC)',
  'Svenska Handelsbanken',
  'Swedbank',
  'Sydbank',
  'Toronto-Dominion Bank (TD)',
  'Triodos Bank',
  'Tyche Bank',
  'UBS Group',
  'Unicredit',
  'United Overseas Bank (UOB)',
  'Valpolicella Benaco BCC',
  'Wells Fargo',
  'Westpac Banking Corporation',
  'Woori Bank',
  'Zurich'
].sort();

/**
 * Normalizza una stringa per la ricerca rimuovendo:
 * - Accenti (é → e, à → a, ô → o, ü → u, ç → c, etc.)
 * - Maiuscole (tutto in minuscolo)
 * - Spazi multipli (ridotti a uno spazio singolo)
 * - Spazi iniziali e finali (trim)
 */
const normalizeString = (str) => {
  if (!str || typeof str !== 'string') return '';
  
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

/**
 * Funzione ottimizzata per la ricerca delle banche
 */
export const searchBanks = (query, limit = 10) => {
  if (!query || query.length < 1) return [];
  
  // ✅ MODIFICATO: usa normalizeString invece di solo toLowerCase
  const normalizedQuery = normalizeString(query);
  
  // ✅ MODIFICATO: normalizza anche i nomi delle banche
  const startsWith = ITALIAN_BANKS.filter(bank => 
    normalizeString(bank).startsWith(normalizedQuery)
  );
  
  // ✅ MODIFICATO: normalizza anche qui
  const contains = ITALIAN_BANKS.filter(bank => {
    const normalizedBank = normalizeString(bank);
    return normalizedBank.includes(normalizedQuery) && 
           !normalizedBank.startsWith(normalizedQuery);
  });
  
  return [...startsWith, ...contains].slice(0, limit);
};

/**
 * Verifica se una banca è valida (esiste nella lista)
 * Usa normalizzazione per match case-insensitive e senza accenti
 * 
 * @param {string} bankName - Nome della banca da verificare
 * @returns {boolean} True se la banca è nella lista
 * 
 * @example
 * isValidBank("Crédit Agricole") // → true
 * isValidBank("credit agricole") // → true
 * isValidBank("Credit Agricole") // → true (anche senza accento!)
 */
export const isValidBank = (bankName) => {
  if (!bankName) return false;
  
  const normalizedInput = normalizeString(bankName);
  
  return ITALIAN_BANKS.some(bank => 
    normalizeString(bank) === normalizedInput
  );
};

/**
 * Ottiene tutte le banche
 */
export const getAllBanks = () => {
  return [...ITALIAN_BANKS];
};

/**
 * Ottiene statistiche sulla lista delle banche
 */
export const getBankStats = () => {
  const total = ITALIAN_BANKS.length;
  const bccCount = ITALIAN_BANKS.filter(bank => bank.includes('BCC')).length;
  const cassaCount = ITALIAN_BANKS.filter(bank => bank.includes('Cassa')).length;
  const bancaCount = ITALIAN_BANKS.filter(bank => bank.startsWith('Banca')).length;
  
  return {
    total,
    bccCount,
    cassaCount,
    bancaCount,
    otherCount: total - bccCount - cassaCount - bancaCount
  };
};

// Costanti utili
export const BANK_TYPES = {
  BCC: 'Banca di Credito Cooperativo',
  CASSA: 'Cassa di Risparmio / Cassa Raiffeisen',
  BANCA: 'Banca Commerciale',
  OTHER: 'Altri Istituti'
};

// Fix: Crea un oggetto e assegnalo prima di esportarlo
const bankDataUtils = {
  ITALIAN_BANKS,
  searchBanks,
  isValidBank,
  getAllBanks,
  getBankStats,
  BANK_TYPES
};

export default bankDataUtils;